import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyCuMNUjFSui0O35tB1_b5INXJSmmYPeD7M",
    authDomain: "matcha-5e965.firebaseapp.com",
    databaseURL: "https://matcha-5e965-default-rtdb.firebaseio.com",
    projectId: "matcha-5e965",
    storageBucket: "matcha-5e965.firebasestorage.app",
    messagingSenderId: "302387249969",
    appId: "1:302387249969:web:70dede0fe8ee7516106610",
    measurementId: "G-0ZL45C3F48"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app)

